import { toInteger, toString, get, toNumber } from "lodash/fp";
import { FieldMap } from "../types/field-map";
import { IPart } from "../types";

const FIELD_MAPPING: FieldMap[] = [
  {
    key: "id",
    field: "id",
    transform: { response: (value: any) => toInteger(value) },
    hidden: true,
  },
  {
    key: "partCategoryId",
    field: "part_category_id",
    transform: { response: (value: any) => toInteger(value) },
    hidden: true,
  },
  {
    key: "partSubcategoryId",
    field: "part_subcategory_id",
    transform: { response: (value: any) => toInteger(value) },
    hidden: true,
  },
  {
    key: "name",
    field: "name",
    transform: { response: (value: any) => toString(value) },
  },
  {
    key: "description",
    field: "description",
    transform: { response: (value: any) => toString(value) },
  },
  {
    key: "priceAmount",
    field: "price_amount",
    transform: { response: (value: any) => toNumber(value) },
  },
  {
    key: "minStock",
    field: "min_stock",
    transform: { response: (value: any) => toInteger(value) },
  },
  {
    key: "maxStock",
    field: "max_stock",
    transform: { response: (value: any) => toInteger(value) },
  },
  {
    key: "totalStock",
    field: "total_stock",
    transform: { response: (value: any) => toInteger(value) },
  },
  {
    key: "markupAmount",
    field: "markup_amount",
    transform: { response: (value: any) => toInteger(value) },
  },
];

export const parseData = (json: any): IPart => {
  return FIELD_MAPPING.reduce((acc: IPart, curr: FieldMap) => {
    const { key, field, transform } = curr;
    const path = typeof field === "string" ? field : field?.response;
    const raw = get(path, json);
    const formatted = transform?.response ? transform?.response(raw) : raw;
    return { ...acc, [key]: formatted };
  }, {} as IPart);
};

export const parsePayload = (json: any) => {
  return FIELD_MAPPING.reduce((acc, curr: FieldMap) => {
    const { key, field, transform } = curr;
    const value = get(key, json);
    return {
      ...acc,
      ...(typeof value != "undefined" && {
        [typeof field === "string" ? field : field.payload]: transform?.payload
          ? transform.payload(value)
          : value,
      }),
    };
  }, {});
}

export const keys = FIELD_MAPPING.filter(({ hidden }) => !hidden).map(
  (field) => ({ column: field.key, path: field.path || field.key })
);
